import React from 'react'
import Layout from '../../common/Layout'
import RateAdviser from '../../features/RateAnAdviser/RateAnAdviserContainer'

export default {
  path: '/adviser/:adviserName/:id/rate',
  async action ({ params }) {
    const adviserId = parseInt(params.id)
    var adviserName = decodeURIComponent(params.adviserName.split('_').join(' '))
    return {
      title: `Allan Gray | ${adviserName} | Rate`,
      component: <Layout backButtonText={'Back to adviser'} containerWell><RateAdviser adviserName={adviserName} adviserId={adviserId} /></Layout>
    }
  }

}
